import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";

export default function LegalPage({ data }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [data]);

  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <div className="relative bg-navy-950 pt-32 pb-16 overflow-hidden grain">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 relative z-10">
          <Link
            data-testid="legal-back-link"
            to="/"
            className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-brand-400 transition-colors"
          >
            <ArrowLeft className="h-4 w-4" /> Ana Sayfaya Dön
          </Link>
          <h1 className="mt-6 font-display font-black text-white text-3xl sm:text-5xl tracking-tight">
            {data.title}
          </h1>
          {data.updated && <p className="mt-3 text-sm text-brand-300">{data.updated}</p>}
        </div>
      </div>

      <article className="max-w-3xl mx-auto px-5 sm:px-8 py-16 space-y-10" data-testid="legal-content">
        {data.sections.map((s, i) => (
          <section key={i}>
            <h2 className="font-display font-bold text-navy-900 text-xl">{s.h}</h2>
            {s.p &&
              s.p.map((para, j) => (
                <p key={j} className="mt-3 text-slate-600 leading-relaxed text-[15px]">
                  {para}
                </p>
              ))}
            {s.list && (
              <ul className="mt-4 grid gap-2">
                {s.list.map((li, j) => (
                  <li key={j} className="flex items-center gap-3 text-slate-600 text-[15px]">
                    <span className="h-1.5 w-1.5 rounded-full bg-brand-500" />
                    {li}
                  </li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </article>

      <Footer />
    </div>
  );
}
